/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import axios from "axios";
export var ContentType;
(function (ContentType) {
  ContentType["Json"] = "application/json";
  ContentType["FormData"] = "multipart/form-data";
  ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
  ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
  instance;
  securityData = null;
  securityWorker;
  secure;
  format;
  constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "/v1/widget/",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }
  setSecurityData = (data) => {
    this.securityData = data;
  };
  mergeRequestParams(params1, params2) {
    const method = params1.method || (params2 && params2.method);
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase()]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }
  stringifyFormItem(formItem) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }
  createFormData(input) {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent = property instanceof Array ? property : [property];
      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }
      return formData;
    }, new FormData());
  }
  request = async ({ secure, path, type, query, format, body, ...params }) => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;
    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body);
    }
    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }
    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}
/**
 * @title Widget Internal API
 * @version 2
 * @baseUrl /v1/widget/
 *
 * API provides the interface for handling fetching and updating state for the widget.
 */
export class Api extends HttpClient {
  v4 = {
    /**
     * @description Returns address form state
     *
     * @tags v4
     * @name AddressFormState
     * @request GET:/v4/address/form/country/{purchase_country}
     */
    addressFormState: (purchaseCountry, params = {}) =>
      this.request({
        path: `/v4/address/form/country/${purchaseCountry}`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * @description Deletes address from address book
     *
     * @tags v4
     * @name DeleteAddressFromAddressBook
     * @request DELETE:/v4/address_book/{address_id}
     */
    deleteAddressFromAddressBook: (addressId, params = {}) =>
      this.request({
        path: `/v4/address_book/${addressId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
    /**
     * @description GetLocale is used to return locale and all translations related to that locale that will be used in populating the widget with localized content.
     *
     * @tags v4
     * @name LocalizationGet
     * @request GET:/v4/localization/{checkout_session_id}
     */
    localizationGet: (checkoutSessionId, query, params = {}) =>
      this.request({
        path: `/v4/localization/${checkoutSessionId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags v4
     * @name AddLocationPost
     * @summary Add location to a session.
     * @request POST:/v4/locations/{checkout_session_id}/session/{session_id}/category/{category_id}/add
     */
    addLocationPost: (
      checkoutSessionId,
      sessionId,
      categoryId,
      query,
      params = {},
    ) =>
      this.request({
        path: `/v4/locations/${checkoutSessionId}/session/${sessionId}/category/${categoryId}/add`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags v4
     * @name LocationsGet
     * @summary Perform free-text query search over the locations in the session.
     * @request GET:/v4/locations/{checkout_session_id}/session/{session_id}/category/{category_id}/query
     */
    locationsGet: (
      checkoutSessionId,
      sessionId,
      categoryId,
      query,
      params = {},
    ) =>
      this.request({
        path: `/v4/locations/${checkoutSessionId}/session/${sessionId}/category/${categoryId}/query`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * @description State get description
     *
     * @tags v4
     * @name StateGet
     * @request GET:/v4/state/{checkout_session_id}
     */
    stateGet: (checkoutSessionId, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * @description Additional information patch
     *
     * @tags v4
     * @name AdditionalInformationPatch
     * @request PATCH:/v4/state/{checkout_session_id}/additional_info
     */
    additionalInformationPatch: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/additional_info`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Returns place details
     *
     * @tags v4
     * @name AddressDetailsPost
     * @request POST:/v4/state/{checkout_session_id}/address/details
     */
    addressDetailsPost: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/address/details`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Return address suggestions
     *
     * @tags v4
     * @name AddressSuggestionsPost
     * @request POST:/v4/state/{checkout_session_id}/address/suggestions
     */
    addressSuggestionsPost: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/address/suggestions`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Validates address
     *
     * @tags v4
     * @name ValidateAddressPost
     * @request POST:/v4/state/{checkout_session_id}/address/validate
     */
    validateAddressPost: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/address/validate`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Deletes address from address book
     *
     * @tags v4
     * @name DeleteAddressFromAddressBookState
     * @request DELETE:/v4/state/{checkout_session_id}/address_book/{address_id}
     */
    deleteAddressFromAddressBookState: (
      checkoutSessionId,
      addressId,
      params = {},
    ) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/address_book/${addressId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
    /**
     * @description Update session billing address and upsert this address to address book
     *
     * @tags v4
     * @name UpdateBillingAddressPost
     * @request POST:/v4/state/{checkout_session_id}/billing_address/update
     */
    updateBillingAddressPost: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/billing_address/update`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Delivery groups context patch
     *
     * @tags v4
     * @name DeliveryGroupsContextPatch
     * @request PATCH:/v4/state/{checkout_session_id}/delivery_groups_context
     */
    deliveryGroupsContextPatch: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/delivery_groups_context`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Update purchase country
     *
     * @tags v4
     * @name UpdatePurchaseCountry
     * @request POST:/v4/state/{checkout_session_id}/purchase_country/update
     */
    updatePurchaseCountry: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/purchase_country/update`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags v4
     * @name UpdateRecipientPost
     * @summary Update recipient and upsert recipient address to address book.
     * @request POST:/v4/state/{checkout_session_id}/recipient/update
     */
    updateRecipientPost: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/recipient/update`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Search address patch
     *
     * @tags v4
     * @name SearchAddressPatch
     * @request PATCH:/v4/state/{checkout_session_id}/search_address
     */
    searchAddressPatch: (checkoutSessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/search_address`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags v4
     * @name AdditionalServicesPatch
     * @request PATCH:/v4/state/{checkout_session_id}/session/{session_id}/additional_services
     */
    additionalServicesPatch: (
      checkoutSessionId,
      sessionId,
      request,
      params = {},
    ) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/session/${sessionId}/additional_services`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description User choice patch
     *
     * @tags v4
     * @name DeliveryAddonStatusPatch
     * @request PATCH:/v4/state/{checkout_session_id}/session/{session_id}/category/{category_id}/delivery_addon/{delivery_addon_id}
     */
    deliveryAddonStatusPatch: (
      checkoutSessionId,
      sessionId,
      categoryId,
      deliveryAddonId,
      request,
      params = {},
    ) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/session/${sessionId}/category/${categoryId}/delivery_addon/${deliveryAddonId}`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description User choice patch
     *
     * @tags v4
     * @name UserChoicePatch
     * @request PATCH:/v4/state/{checkout_session_id}/session/{session_id}/user_choice
     */
    userChoicePatch: (checkoutSessionId, sessionId, request, params = {}) =>
      this.request({
        path: `/v4/state/${checkoutSessionId}/session/${sessionId}/user_choice`,
        method: "PATCH",
        body: request,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * @description Token refresh
     *
     * @tags v4
     * @name TokenGet
     * @request GET:/v4/state_events_token/{checkout_session_id}
     */
    tokenGet: (checkoutSessionId, params = {}) =>
      this.request({
        path: `/v4/state_events_token/${checkoutSessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
